export const API = import.meta.env.VITE_API;
export const API_SHORT = import.meta.env.VITE_API_SHORT;
export const APP_LINK = import.meta.env.VITE_APP_LINK;
export const TECHNICIAN_BOARD_LINK = import.meta.env.VITE_TECHNICIAN_BOARD_LINK;
export const LANG = 'ger';
export const WEBSITE = 'https://www.we-wash.com';
export const GOOGLE_MAPS_API_KEY = 'AIzaSyAlzhyVsF_7f4nHQV6NX347vjdja0lHzus';
